import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        sign: '',
        key: '',
        publicKey: '',
        exponent: '',
        ssoUserId: '',
        userInfo: {},
        csrf: '',
        _csrf: '',
        fp: '',
        tongjiUrl: '',
        // 否展示报名后的引导文案
        guideInfo: null,
    },
    getters: {
        sign: state => state.sign,
        key: state => state.key,
        publicKey: state => state.publicKey,
        exponent: state => state.exponent,
        ssoUserId: state => {
            return state.userInfo;
        },
        userInfo: state => {
            return state.userInfo;
        },
        csrf: state => state.csrf,
        tongjiUrl: state => state.tongjiUrl,
        fp: state => state.fp,
        guideInfo: state => state.guideInfo,
    },
    mutations: {
        setPublicKey(state, payload) {
            state.publicKey = payload;
        },
        setExponent(state, payload) {
            state.exponent = payload;
        },
        setSign(state, payload) {
            state.sign = payload;
        },
        setKey(state, payload) {
            state.key = payload;
        },
        setSsoUserId(state, payload) {
            state.ssoUserId = payload;
        },
        setUserInfo(state, payload) {
            state.userInfo = payload;
        },
        setCsrf(state, payload) {
            state.csrf = payload;
        },
        setSiteCSRF(state, token) {
            state._csrf = token;
        },
        setFP(state, fp) {
            state.fp = fp;
        },
        setTongjiUrl(state, tongjiUrl) {
            state.tongjiUrl = tongjiUrl;
        },
        GET_DATE_GET_CMPT_GUIDE_INFO(state, guideInfo) {
            state.guideInfo = guideInfo
        }
    },
    actions: {
        initState({ commit }) {
            const { sign, key, publicKey, exponent, user, ssoUserId, csrf, _csrf } = (window as any).INIT_DATA;
            commit('setSign', sign);
            commit('setKey', key);
            commit('setPublicKey', publicKey);
            commit('setExponent', exponent);
            commit('setUserInfo', user);
            commit('setSsoUserId', ssoUserId);
            commit('setCsrf', csrf);
            commit('setSiteCSRF', _csrf);
        },
        initEnctype({ commit }, payload) {
            const { sign, key, publicKey, exponent, user, ssoUserId, csrf, _csrf, tongjiUrl, fp } = payload;
            commit('setSign', sign);
            commit('setKey', key);
            commit('setPublicKey', publicKey);
            commit('setExponent', exponent);
            commit('setUserInfo', JSON.parse(user));
            commit('setSsoUserId', ssoUserId);
            commit('setCsrf', csrf);
            commit('setTongjiUrl', tongjiUrl);
            commit('setFP', fp);
            // commit('setSiteCSRF', _csrf);
        },
        updateCsrf({ commit }, token) {
            commit('setCsrf', token);
        },
    },
    modules: {},
});
